import { type ReactElement } from 'react'
import { isTeamId } from '@terros/common'
import { Link } from '@tanstack/react-router'
import { Anchor } from '@mantine/core'
import { usePermissionCheck, useProfile, useTranslation, useWorkflows } from '@front/model'

export function FlaggedWorkflowLinks(): ReactElement | null {
  const { t } = useTranslation()
  const { company } = useProfile()
  const workflows = useWorkflows()
  const teamIds = workflows.data?.flatMap((workflow) => (workflow.visibleTo ?? []).filter(isTeamId)) ?? []
  const permission = usePermissionCheck({
    permissionType: 'workflow:manage',
    targetId: [company?.companyId, ...teamIds],
  })
  if (!permission.isSuccess || permission.data !== true || permission.isFetching) return null
  return (
    <Anchor component={Link} to='/settings/workflow' size='sm'>
      {t('Edit flag stages in Workflows')}
    </Anchor>
  )
}
